var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sku-select" },
    [
      _c(
        "el-button",
        {
          staticStyle: { "margin-bottom": "20px" },
          attrs: { size: "mini", type: "primary" },
          on: {
            click: function ($event) {
              return _vm.openInit()
            },
          },
        },
        [_vm._v("选择用户")]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: "选择用户",
            top: "100px",
            width: "60vw",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  staticStyle: { "margin-top": "20px" },
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: "",
                        size: "small",
                        "label-width": "120px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户搜索" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticStyle: { width: "400px" },
                              attrs: {
                                placeholder: "请输入姓名或手机号",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.keywords,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "keywords", $$v)
                                },
                                expression: "listPram.keywords",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.handerSearch },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "小程序客户" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                placeholder: "请选择小程序客户",
                                clearable: "",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handerSearch(0)
                                },
                              },
                              model: {
                                value: _vm.listPram.customerId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "customerId", $$v)
                                },
                                expression: "listPram.customerId",
                              },
                            },
                            _vm._l(_vm.customers, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  ref: "tableListRef",
                  staticClass: "table",
                  attrs: {
                    data: _vm.listData.list,
                    size: "mini",
                    height: "500",
                    "highlight-current-row": "",
                    "header-cell-style": { fontWeight: "bold" },
                  },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "55" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "uid", label: "用户ID", "min-width": "50" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "nickname",
                      label: "姓名",
                      "min-width": "150",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "phone",
                      label: "手机号",
                      "min-width": "180",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "groupName",
                      label: "分组",
                      "min-width": "180",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "customerName",
                      label: "小程序客户",
                      "min-width": "100",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.listPram.page,
                  "page-sizes": _vm.constants.page.limit,
                  layout: _vm.constants.page.layout,
                  total: _vm.listData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: !_vm.selectIds || !_vm.selectIds.length,
                  },
                  on: { click: _vm.handerSubmit },
                },
                [_vm._v("确认调整")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }